import { DeviceService } from '@/services/device.service'
import { MerchantService } from '@/services/merchant.service'
import { StaffService } from '@/services/staff.service'
import Config from '@/thirdParty/config'
import FormDevice from './_form_device.vue'
export default {
  data() {
    return {
      deviceTypeOptions: [],
      typeAppendixOptions: Config.deviceLocationAppendixType,
      locIdOptions: [],
      saleOptions: [],
      managerOptions: [],
      verifyOptions: Config.verifyOptions,
      statusOptions: Config.deviceLocationStatus,
    }
  },
  components: { FormDevice },
  created() {
    this.getDeviceTypeOptions()
    this.getSaleOptions()
    this.getManagerOptions()
  },
  methods: {
    async getDeviceTypeOptions() {
      const res = await DeviceService.listCatDevice({ service: 'MPOS' })
      this.deviceTypeOptions = res?.data?.categoryList?.map(s => ({ id: s.id, text: s.name })) ?? []
    },
    async getLocIdOptions() {
      const res = await MerchantService.listLocMcId({
        customerId: this.search.customerId,
      })
      this.locIdOptions = res?.data?.map(s => ({ id: s.id, text: s.areaName })) ?? []
    },
    async getSaleOptions() {
      const data = await StaffService.getStaffByIdSuperior({
        userId: this.userData.userId,
      })
      this.saleOptions = data?.data?.map(e => ({ id: e.userId, text: e.name })) ?? []
    },
    async getManagerOptions() {
      const data = await StaffService.superiors()
      this.managerOptions = data?.data?.map(e => ({ id: e.id, text: e.name })) ?? []
    },
    canCreate() {
      return this.canAccessMx('CNPS_CSTM_LOC_SERIAL_CREATE')
    },
    canUpdate() {
      return this.canAccessMx('CNPS_CSTM_LOC_SERIAL_UPDATE')
    },
    canVerify(item) {
      return (
        (!item.verify || item.verify === 'UNVERIFIED') &&
        this.canAccessMx('CNPS_CSTM_LOC_SERIAL_UPDATE')
      )
    },
    canUnVerify(item) {
      return (
        (!item.verify || item.verify === 'VERIFIED') &&
        this.canAccessMx('CNPS_CSTM_LOC_SERIAL_UPDATE')
      )
    },
    canLock(item) {
      return this.canAccessMx('CNPS_CSTM_LOC_SERIAL_UPDATE')
    },
    canUnLock(item) {
      return this.canAccessMx('CNPS_CSTM_LOC_SERIAL_UPDATE')
    },
    detail(id) {
      const routeData = this.$router.resolve({
        path: `/device-location/${id}`,
      })
      window.open(routeData.href, '_blank')
    },
    async verify(item, isVerify) {
      const { value: flag, note } = await this.rejectMx(
        isVerify
          ? `Xác thực thông tin thiết bị serial: ${item.serial}`
          : `Bỏ xác thực thông tin thiết bị serial: ${item.serial}`
      )
      if (flag === true) {
        try {
          this.loading = true
          const res = await MerchantService.verifyDeviceLocation({
            id: item.dataId,
            verify: isVerify ? 'VERIFIED' : 'UNVERIFIED',
            reason: note,
          })
          if (res.success === true) {
            await this.fetchData()
            this.showSuccessMx(
              isVerify
                ? `Xác thực thông tin thiết bị serial: ${item.serial} thành công`
                : `Bỏ xác thực thông tin thiết bị serial: ${item.serial} thành công`
            )
          } else this.showFailMx(res.message)
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      }
    },
    async lock(item, isLock) {
      const { value: flag, note } = await this.rejectMx(
        isLock ? `Khoá thiết bị serial: ${item.serial}` : `Mở khoá thiết bị serial: ${item.serial}`
      )
      if (flag === true) {
        try {
          this.loading = true
          const res = await MerchantService.lockDeviceLocation({
            id: item.dataId,
            changeLock: isLock ? 'LOCKED' : 'UNLOCKED',
            reason: note,
          })
          if (res.success === true) {
            await this.fetchData()
            this.showSuccessMx(
              isLock
                ? `Khoá thiết bị serial: ${item.serial} thành công`
                : `Mở khoá thiết bị serial: ${item.serial} thành công`
            )
          } else this.showFailMx(res.message)
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      }
    },
    openFormDevice(title, params) {
      this.showModalComponentMx(title, {
        name: FormDevice,
        props: {
          deviceTypeOptions: this.deviceTypeOptions,
          typeAppendixOptions: this.typeAppendixOptions,
          ...params,
        },
        id: '_form_device',
        footerClass: 'd-none',
      }).then(_ => {
        this.fetchData()
      })
    },
  },
}
